import { apiClient } from "@/lib/apiClient";

export interface Number {
  id: string;
  e164Number: string;
  friendlyName: string;
  country: string;
  region?: string;
  locality?: string;
  voiceUrl?: string;
  boughtAt: string;
  externalId?: string;
  createdAt: string;
  updatedAt: string;
  source: "twilio" | "telnyx";
  companyId?: string;
  company?: {
    id: string;
    name: string;
  };
}

export interface CreateNumberData {
  e164Number: string;
  friendlyName: string;
  country: string;
  region?: string;
  locality?: string;
  voiceUrl?: string;
  boughtAt?: string;
  source?: "twilio" | "telnyx";
  companyId?: string;
  externalId?: string;
}

export interface UpdateNumberData {
  friendlyName?: string;
  country?: string;
  region?: string;
  locality?: string;
  voiceUrl?: string;
  boughtAt?: string;
  source?: "twilio" | "telnyx";
  companyId?: string | null;
  externalId?: string;
}

export interface NumberQueryParams {
  companyId?: string;
  source?: string;
  country?: string;
  friendlyName?: string;
}

class NumberApiService {
  async getAllNumbers(queryParams?: NumberQueryParams): Promise<Number[]> {
    const params = new URLSearchParams();

    if (queryParams) {
      Object.entries(queryParams).forEach(([key, value]) => {
        if (value) {
          params.set(key, value);
        }
      });
    }

    const endpoint = `/v1/numbers${
      params.toString() ? `?${params.toString()}` : ""
    }`;
    return apiClient.get<Number[]>(endpoint);
  }

  async getNumber(id: string): Promise<Number> {
    return apiClient.get<Number>(`/v1/numbers/${id}`);
  }

  async createNumber(numberData: CreateNumberData): Promise<Number> {
    return apiClient.post<Number>(`/v1/numbers`, { data: numberData });
  }

  async updateNumber(
    id: string,
    numberData: UpdateNumberData
  ): Promise<Number> {
    return apiClient.put<Number>(`/v1/numbers/${id}`, { data: numberData });
  }

  async deleteNumber(id: string): Promise<void> {
    return apiClient.delete<void>(`/v1/numbers/${id}`);
  }
}

export const numberApi = new NumberApiService();
